import React from 'react';

import classNames from 'classnames';

import { textClassNamesBySize, textClassNamesByVariant } from './constants';
import { Icon } from './Icon';
import { Size, Variant } from './types';

type Props = {
  children: React.ReactNode;
  variant: Variant;
  size?: Size;
  className?: string;
  hiddenIcon?: boolean;
  customIcon?: React.ReactNode;
};

export const InlineAlert: React.FC<Props> = ({
  hiddenIcon,
  children,
  variant,
  size = 'sm',
  className,
  customIcon,
}) => (
  <div className={classNames('flex items-start gap-xxs grow', className)}>
    {!hiddenIcon && <Icon customIcon={customIcon} variant={variant} size={size} />}
    <div
      className={classNames(
        'w-full flex font-normal',
        textClassNamesByVariant[variant],
        textClassNamesBySize[size],
      )}
    >
      {children}
    </div>
  </div>
);
